import React, { memo, useCallback } from "react";
import { Card, Input, Controller, Button, SelectBox } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, Switch, message } from "antd";
import { useGetAuthorityFindPermissions, usePostAuthorityAddNewRole } from "core";

const NAME = "name";
const PERMISSIONS = "permissions";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};


const AddRole = memo(() => {
  const { i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

 const {data:{data}={},isFetching}=useGetAuthorityFindPermissions()
  const methods = useForm({
    defaultValues: {
      name: "",
      permissions: [],
    },
  });

  const { handleSubmit, reset } = methods;
  const { mutate, isPending } = usePostAuthorityAddNewRole({
    onSuccess: () => {
      messageApi.open({
        type: 'success',
        content: i18n.t('done'),
      });
      reset();
    },
  });

  const onSubmit = useCallback(
    ({ name, permissions }: { name:string ; permissions: string[] }) => {
      mutate({
        requestBody: {
         name,
         permissions
        },
      });
    },
    []
  );
  
  const permissionsItem = data?.map((item: { name: string }) => {
    return {
      value: item.name,
      label: item.name,
    };
  });
  return (
    <>
 {contextHolder}

      <Card title={i18n.t("addRole")}>
        <FormProvider {...methods}>
          <Form
            {...layout}
            name="nest-messages"
            onFinish={handleSubmit(onSubmit)}
          >
            <Form.Item>
              <Controller name={NAME}>
                <Input placeholder={i18n.t("roleName")} />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller name={PERMISSIONS}>
                <SelectBox
                 placeholder={i18n.t("enter")}
                 mode="tags"
                  label={i18n.t("permissions")}
                  options={permissionsItem}
                />
              </Controller>
            </Form.Item>

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
              <Button
                style={{ width: "100px" }}
                type="primary"
                isLoading={isPending}
                htmlType="submit"
              >
                {i18n.t("done")}
              </Button>
            </Form.Item>

          </Form>
        </FormProvider>
      </Card>
    </>
  );
});
export { AddRole };
